import { FC } from 'react'
import CompanyModal from '@modals/CompanyModal'
import ModalOnRoute from '@templates/ModalOnRoute'

const CompanyModalOnRoute: FC = () => {
  return <ModalOnRoute Component={CompanyModal} withoutCloseOnOutsideClick />
}

export default CompanyModalOnRoute
